import type { ButtonHTMLAttributes, ReactNode } from "react";
import "./Button.scss";

type ButtonVariant = "primary" | "secondary" | "ghost" | "danger";

type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  children?: ReactNode;
  fullWidth?: boolean;
  icon?: ReactNode;
  iconUrl?: string;
  variant?: ButtonVariant;
};

export default function Button({
  children,
  className = "",
  fullWidth = false,
  icon,
  iconUrl,
  variant = "primary",
  type = "button",
  ...props
}: ButtonProps) {
  return (
    <button
      className={`button button--${variant} ${fullWidth ? "button--full-width" : ""} ${className}`.trim()}
      type={type}
      {...props}
    >
      {icon ??
        (iconUrl && (
          <img
            className="button-icon"
            src={iconUrl}
            alt=""
            aria-hidden="true"
          />
        ))}
      {children}
    </button>
  );
}
